angular.module 'zc.commonApi'

.factory 'CampaignUsers', (FacadeV2) ->

  class CampaignUsers

    @aggregate: (paths, params) ->
      FacadeV2.request "/apikeys/#{paths.apikey}/campaign_users/#{paths.dimension}/aggregate", {params}
      .then (res) ->
        res.data

    @find: (paths, params) ->
      FacadeV2.request "/apikeys/#{paths.apikey}/campaign_users/#{paths.dimension}/find", {params}
      .then (res) ->
        res.data

    @findConversions: (paths, params) ->
      FacadeV2.request "/apikeys/#{paths.apikey}/campaign_users/#{paths.dimension}/find_conversions", {params}
      .then (res) ->
        res.data



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/facade/campaign_users.service.coffee